import { render, staticRenderFns } from "./SchoolRow.vue?vue&type=template&id=91cb28f6&"
import script from "./SchoolRow.vue?vue&type=script&lang=js&"
export * from "./SchoolRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports